import { assoc, propOr } from 'ramda';

import evolve from './evolve';
import { documentType, education } from './commonMapper';
import PersonMapper from './personMapper';
import EventMapper from './eventMapper';
import { createGetWorksheetItems } from './worksheetMapper';

const getWorksheetMassItems = createGetWorksheetItems('stage');
const partsInProjectMass = propOr([], 'parts');

const prevStageResults = list => Array.isArray(list) ? (
    list.map(item => ({ text: item.comment }))
) : { text: list.comment };

const workplace = (workplace = {}) => {
    const { company, dateFrom : beginWork, dateTo : endWork } = workplace;
    const work = PersonMapper.work({ beginWork, endWork });

    return `${company} ${work.experience} ${work.stillWorks}`;
};

export default data => {
    const addedPeople = assoc('people', data.people && getWorksheetMassItems(data.people) || [], data);

    return evolve({
        people: {
            workplace: workplace,
            documents: documentType,
            education: education,
            partsInProject: partsInProjectMass,
            prevStageResults: prevStageResults,
            working: { text: EventMapper.text }
        }
    })(addedPeople);
};
